import { PpvFollowUpMessagesRestControllerService } from '@api'

function updateToggle(creatorId: number, state: boolean) {
  return PpvFollowUpMessagesRestControllerService.apiToggleFollowUpMessages({
    creatorId,
    requestBody: { state },
  })
}

function updateNotSeenToggle(creatorId: number, state: boolean) {
  return PpvFollowUpMessagesRestControllerService.apiToggleFollowUpMessagesNotSeen(
    {
      creatorId,
      requestBody: { state },
    },
  )
}

function updateDelay(creatorId: number, minutes: number) {
  return PpvFollowUpMessagesRestControllerService.apiSetFollowUpMessagesMinutes(
    {
      creatorId,
      requestBody: { minutes },
    },
  )
}

function deleteMessage(creatorId: number, messageId: number) {
  return PpvFollowUpMessagesRestControllerService.removeFollowUpMessage({
    creatorId,
    id: messageId,
  })
}

export const followUpMessageService = {
  updateToggle,
  updateNotSeenToggle,
  updateDelay,
  deleteMessage,
}
